import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import SiteShell from "../components/site/SiteShell";
import { Button } from "../components/site/ui";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <SiteShell title="Checkout canceled — GoBuildWeb" testId="payment-cancel-page">
      <section className="grid min-h-[70vh] place-items-center pt-[72px]">
        <div className="mx-auto max-w-lg px-5 py-20 text-center">
          <XCircle className="mx-auto text-zinc-500" size={48} />
          <h1 className="mt-5 font-display text-3xl font-bold text-white">Checkout canceled</h1>
          <p className="mt-3 text-zinc-300">No charge was made. Whenever you're ready, we're here.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button onClick={() => navigate("/pricing")}>View Pricing</Button>
            <Button variant="secondary" icon={false} onClick={() => navigate("/get-started")}>Talk to Us</Button>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
